// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__nCgaX","input":"SearchBar_input__dUHyE","btn":"SearchBar_btn__YQsfe"};